import apiService from './api'

/**
 * Inventory API Service
 * Handles all inventory-related API endpoints
 */

export const inventoryApi = {
  /**
   * Get user inventory
   * Returns: { inventory: [...], me: {...}, alert?: string, error?: string }
   */
  async getInventory() {
    try {
      const response = await apiService.get('/api/inventory/')
      return response
    } catch (error) {
      console.error('Failed to fetch inventory:', error)
      throw error
    }
  },

  /**
   * Get item details
   * @param {number} itemId - The ID of the item
   * Returns: { item: {...}, alert?: string, error?: string }
   */
  async getItemDetails(itemId) {
    try {
      const response = await apiService.get(`/api/inventory/${itemId}/`)
      return response
    } catch (error) {
      console.error(`Failed to fetch item ${itemId} details:`, error)
      throw error
    }
  },

  /**
   * Sell an item from inventory (new API endpoint)
   * @param {string} itemId - The ID of the item to sell
   * Returns: { sale: {...}, me: {...}, alert?: string, error?: string }
   */
  async saleItem(itemId) {
    try {
      const response = await apiService.get(`/api/inventory/${itemId}/sale/`)
      return response
    } catch (error) {
      console.error(`Failed to sell item ${itemId}:`, error)
      throw error
    }
  },

  /**
   * Send item to Steam (withdraw to Steam)
   * @param {string} itemId - The ID of the item to send
   * Returns: { send: {...}, me: {...}, alert?: string, error?: string }
   */
  async sendItem(itemId) {
    try {
      const response = await apiService.get(`/api/inventory/${itemId}/send/`)
      return response
    } catch (error) {
      console.error(`Failed to send item ${itemId}:`, error)
      throw error
    }
  },

  /**
   * Sell all available items at once
   * Returns: { sale: [...], me: {...}, alert?: string, error?: string }
   * Note: If only 1 item is sold, format will be like single sale (no array)
   */
  async saleAllItems() {
    try {
      const response = await apiService.get('/api/inventory/sale/all/')
      return response
    } catch (error) {
      console.error('Failed to sell all items:', error)
      throw error
    }
  },

  /**
   * Sell selected items by IDs
   * @param {string[]} itemIds - Array of item IDs to sell
   * Returns: { sale: [...], me: {...}, alert?: string, error?: string }
   */
  async saleSelectedItems(itemIds) {
    try {
      const response = await apiService.post('/api/inventory/sale/', itemIds)
      return response
    } catch (error) {
      console.error('Failed to sell selected items:', error)
      throw error
    }
  }
}

export default inventoryApi
